import { IntlShape } from 'react-intl';
import { minLength8, containsNumber, containsUpperAlpha } from './validate';
// eslint-disable-next-line import/no-named-as-default
import messages from './messages';

export const passwordRequirements = (intl: IntlShape, uppercase = false) => {
  const requirements = [
    {
      id: 'minLength8',
      validate: minLength8,
      message: intl.formatMessage(messages.passwordRequirementsMinLength),
    },
    {
      id: 'containsNumber',
      validate: containsNumber,
      message: intl.formatMessage(messages.passwordRequirementsContainsNumber),
    },
  ];
  const upppercaseRequirements = {
    id: 'containsUppercase',
    validate: containsUpperAlpha,
    message: intl.formatMessage(messages.passwordRequirementsContainsUppercase),
  };
  if (uppercase) requirements.push(upppercaseRequirements);
  return requirements;
};
